import * as THREE from "three";

// Keep the authoring preview and Viewer on the same built-in environments.
export const BUILTIN_ENVIRONMENTS = Object.freeze({
    Cannon_Exterior: "Cannon Exterior",
    footprint_court: "Footprint Court",
    pisa: "Pisa",
    doge2: "Doge's palace",
    ennis: "Dining room",
    field: "Field",
    helipad: "Helipad Goldenhour",
    papermill: "Papermill Ruins",
    neutral: "Studio Neutral",
    Colorful_Studio: "Colorful Studio",
    Wide_Street: "Wide Street",
    "EG-T_ZEBRA_ROOM": "EG-T Zebra Room"
});

export function getViewerToneMapping(name) {
    const settings = {
        "Khronos PBR Neutral": { mode: THREE.AgXToneMapping ?? THREE.ACESFilmicToneMapping, exposureBoost: 1 },
        "ACES Filmic Tone Mapping (Hill - Exposure Boost)": { mode: THREE.ACESFilmicToneMapping, exposureBoost: 1 / 0.6 },
        "ACES Filmic Tone Mapping (Narkowicz)": { mode: THREE.ACESFilmicToneMapping, exposureBoost: 1 },
        "ACES Filmic Tone Mapping (Hill)": { mode: THREE.CineonToneMapping, exposureBoost: 1 },
        "None (Linear mapping, clamped at 1.0)": { mode: THREE.NoToneMapping, exposureBoost: 1 }
    };
    return Object.hasOwn(settings, name) ? settings[name] : settings["Khronos PBR Neutral"];
}

export function getBuiltinEnvironment(key) {
    const id = Object.hasOwn(BUILTIN_ENVIRONMENTS, key) ? key : "Cannon_Exterior";
    return { id, name: BUILTIN_ENVIRONMENTS[id], fallback: id !== key };
}

export function applyModelEnvironmentIntensity(root, state, preferences) {
    const intensity = preferences.ibl ? Math.pow(10, preferences.iblIntensity) : 0;
    const materials = new Set();
    root.traverse(node => {
        for (const material of Array.isArray(node.material) ? node.material : [node.material]) {
            if (material) materials.add(material);
        }
    });
    // Include finishes that will only be attached when a State is selected.
    for (const map of [state?.materialsByIndex, state?.innoWorksMaterialsById]) {
        map?.forEach(material => materials.add(material));
    }
    materials.forEach(material => {
        if ("envMapIntensity" in material) material.envMapIntensity = intensity;
    });
}
